var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPopularActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Popular_Active",
    "data-name": "Popular Active",
    transform: "translate(-39 -870)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M87.932,16.394c-.367-4.176-2.589-6.793-4.549-9.1C81.568,5.154,80,3.308,80,.584a.58.58,0,0,0-.362-.519.74.74,0,0,0-.693.044,14.979,14.979,0,0,0-6.258,7.914A22.727,22.727,0,0,0,72,13.94c-2.719-.508-3.335-4.067-3.341-4.105a.6.6,0,0,0-.347-.433.749.749,0,0,0-.6-.01c-.143.06-3.5,1.553-3.695,7.512-.014.2-.014.4-.014.6C64,23.289,69.383,28,76,28a.106.106,0,0,0,.027,0h.008C82.635,27.983,88,23.279,88,17.5,88,17.209,87.932,16.394,87.932,16.394ZM76,26.833A3.876,3.876,0,0,1,72,23.1c0-.07,0-.141.005-.227a4.23,4.23,0,0,1,.421-1.852,2.426,2.426,0,0,0,2.2,1.4.629.629,0,0,0,.667-.583,10.253,10.253,0,0,1,.256-2.653,5.444,5.444,0,0,1,1.35-2.236,7.289,7.289,0,0,0,1.374,2.206A6.247,6.247,0,0,1,79.983,22.8c.008.1.017.2.017.309A3.876,3.876,0,0,1,76,26.833Z",
    transform: "translate(-25 870)",
    fill: "#ffcfe9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopularActive);
export default __webpack_public_path__ + "static/media/icon_popular_active.8adde02553e57214d421d26a760145e0.svg";
export { ForwardRef as ReactComponent };